module.exports = __webpack_public_path__ + "img/wave-adventure_3.b8f4ac3e.jpg";